import { CSSProperties } from 'react';
import { ThemeOptions } from '@mui/material/styles';
import type { } from '@mui/lab/themeAugmentation';


declare module '@mui/material/styles' {
    interface TypographyVariants {
        boldTitle1: CSSProperties;
        regularHeader2: CSSProperties;
        mediumCaption1: CSSProperties;
        mediumBody2: CSSProperties;
        regularCaption3: CSSProperties;
        mediumCaption2: CSSProperties;
        mediumMicro1: CSSProperties;
        boldCaption1: CSSProperties;
        regularCaption1: CSSProperties;
        boldBody2: CSSProperties;
        regularBody2: CSSProperties;
        boldBody1: CSSProperties;
        mediumCaption3: CSSProperties;
        mediumBody1: CSSProperties;
        boldCaption2: CSSProperties;
        mediumHeader2: CSSProperties;
        regularCaption2: CSSProperties;
        mediumHeader1: CSSProperties;
        regularHeader1: CSSProperties;
        boldTitle3: CSSProperties;
        boldHeader1: CSSProperties;
        boldTitle5: CSSProperties;
        boldHeader2: CSSProperties;
        boldTitle2: CSSProperties;
        boldTitle4: CSSProperties;
    }

    interface TypographyVariantsOptions {
        boldTitle1?: CSSProperties;
        regularHeader2?: CSSProperties;
        mediumCaption1?: CSSProperties;
        mediumBody2?: CSSProperties;
        regularCaption3?: CSSProperties;
        mediumCaption2?: CSSProperties;
        mediumMicro1?: CSSProperties;
        boldCaption1?: CSSProperties;
        regularCaption1?: CSSProperties;
        boldBody2?: CSSProperties;
        regularBody2?: CSSProperties;
        boldBody1?: CSSProperties;
        mediumCaption3?: CSSProperties;
        mediumBody1?: CSSProperties;
        boldCaption2?: CSSProperties;
        mediumHeader2?: CSSProperties;
        regularCaption2?: CSSProperties;
        mediumHeader1?: CSSProperties;
        regularHeader1?: CSSProperties;
        boldTitle3?: CSSProperties;
        boldHeader1?: CSSProperties;
        boldTitle5?: CSSProperties;
        boldHeader2?: CSSProperties;
        boldTitle2?: CSSProperties;
        boldTitle4?: CSSProperties;
    }
}

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        boldTitle1: true;
        regularHeader2: true;
        mediumCaption1: true;
        mediumBody2: true;
        regularCaption3: true;
        mediumCaption2: true;
        mediumMicro1: true;
        boldCaption1: true;
        regularCaption1: true;
        boldBody2: true;
        regularBody2: true;
        boldBody1: true;
        mediumCaption3: true;
        mediumBody1: true;
        boldCaption2: true;
        mediumHeader2: true;
        regularCaption2: true;
        mediumHeader1: true;
        regularHeader1: true;
        boldTitle3: true;
        boldHeader1: true;
        boldTitle5: true;
        boldHeader2: true;
        boldTitle2: true;
        boldTitle4: true;
        body2: false;
        body1: false;
        caption: false;
        button: false;
        h1: false;
        h2: false;
        h3: false;
        h4: false;
        h5: false;
        h6: false;
        subtitle1: false;
        subtitle2: false;
        overline: false;
        inherit: false;
    }
}

export const typographyOptions: ThemeOptions = {
    typography: {
        boldTitle1: {
            fontSize: '48px',
            fontWeight: 700,
            lineHeight: '64px',
            letterSpacing: '0.48px',
        },
        regularHeader2: {
            fontSize: '20px',
            fontWeight: 400,
            lineHeight: '32px',
            letterSpacing: '0.2px',
        },
        mediumCaption1: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '0.14px',
        },
        mediumBody2: {
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: '0.16px',
        },
        regularCaption3: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '16px',
            letterSpacing: '0.12px',
        },
        mediumCaption2: {
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: '18px',
            letterSpacing: '0.12px',
        },
        mediumMicro1: {
            fontSize: '10px',
            fontWeight: 500,
            lineHeight: '14px',
            letterSpacing: '0.1px',
        },
        boldCaption1: {
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '20px',
            letterSpacing: '0.14px',
        },
        regularCaption1: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '0.14px',
        },
        boldBody2: {
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '0.16px',
        },
        regularBody2: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0.16px',
        },
        boldBody1: {
            fontSize: '18px',
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '0.18px',
        },
        mediumCaption3: {
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: '16px',
            letterSpacing: '0.12px',
        },
        mediumBody1: {
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: '0.18px',
        },
        boldCaption2: {
            fontSize: '12px',
            fontWeight: 700,
            lineHeight: '18px',
            letterSpacing: '0.12px',
        },
        mediumHeader2: {
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: '32px',
            letterSpacing: '0.2px',
        },
        regularCaption2: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '18px',
            letterSpacing: '0.12px',
        },
        mediumHeader1: {
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '32px',
            letterSpacing: '0.24px',
        },
        regularHeader1: {
            fontSize: '24px',
            fontWeight: 400,
            lineHeight: '36px',
            letterSpacing: '0.24px',
        },
        boldTitle3: {
            fontSize: '36px',
            fontWeight: 700,
            lineHeight: '48px',
            letterSpacing: '0.36px',
        },
        boldHeader1: {
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '36px',
            letterSpacing: '0.24px',
        },
        boldTitle5: {
            fontSize: '28px',
            fontWeight: 700,
            lineHeight: '40px',
            letterSpacing: '0.28px',
        },
        boldHeader2: {
            fontSize: '20px',
            fontWeight: 700,
            lineHeight: '32px',
            letterSpacing: '0.2px',
        },
        boldTitle2: {
            fontSize: '40px',
            fontWeight: 700,
            lineHeight: '56px',
            letterSpacing: '0.4px',
        },
        boldTitle4: {
            fontSize: '32px',
            fontWeight: 700,
            lineHeight: '44px',
            letterSpacing: '0.32px',
        },
    },
};
